module.exports = __webpack_public_path__ + "img/settings-icon.a1fcddb5.svg";